import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueI18n from 'vue-i18n'
import 'font-awesome/css/font-awesome.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import VueLazyload from 'vue-lazyload'

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(VueLazyload);

//多语言配置
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import thLocale from 'element-ui/lib/locale/lang/th'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import viLocale from 'element-ui/lib/locale/lang/vi'
import locales from './lang/all'
const cuLang = localStorage.getItem('cuLang');
const locLang = navigator.language;
if(!cuLang){
  if (locLang === 'zh-CN' || locLang === 'en-US' || locLang === 'th-TH' || locLang === 'zh-TW'|| locLang === 'vi-VN') {
    Vue.config.lang = locLang;
  } else {
    Vue.config.lang = 'en-US';
  }
} else {
  Vue.config.lang = cuLang;
}
let zhCnLocales = {};
let enUsLocales = {};
let thThLocales = {};
let zhTwLocales = {};
let viTwLocales = {};
Object.keys(locales).forEach(function (langKey) {
    zhCnLocales[langKey] = locales[langKey]['zh-CN'];
    enUsLocales[langKey] = locales[langKey]['en-US'];
    thThLocales[langKey] = locales[langKey]['th-TH'];
    zhTwLocales[langKey] = locales[langKey]['zh-TW'];
    viTwLocales[langKey] = locales[langKey]['vi-VN'];
});

Vue.locale('zh-CN', Object.assign(zhCnLocales, zhLocale));
Vue.locale('en-US', Object.assign(enUsLocales, enLocale));
Vue.locale('th-TH', Object.assign(thThLocales, thLocale));
Vue.locale('zh-TW', Object.assign(zhTwLocales, twLocale));
Vue.locale('vi-VN', Object.assign(viTwLocales, viLocale));

//路由配置
import routes from './routes'
const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        return {x: 0, y: 0}
    }
});

router.beforeEach(({meta, path}, from, next) => {
    store.commit('setLoginPath', '');
    const {auth = true} = meta;
    const isLogin = Boolean(store.state.user.accessToken);
    if (auth && !isLogin) {
        store.commit('setLoginPath', path);
        return store.commit('controlLoginPopup', true);
    }
    next()
});

//api请求配置
Vue.http.options.root = process.env.API_URL;

// vuex配置
import store from './store'

// 图片懒加载配置
Vue.use(VueLazyload, {
    preLoad: 1.3,
    loading: 'static/img/partial/loading.svg',
    attempt: 1
});

const vm = new Vue({
    el: '#app',
    template: '<App/>',
    components: {App},
    router,
    store
})



// WEBPACK FOOTER //
// ./src/main.js